import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { AuthRedirectGuard } from '@core/guards/auth-redirect.guard';
export const routes: Routes = [
    // Keycloak OAuth2 callback – no guard, must sit before all other routes
    {
        path: 'auth/callback',
        data: { headerType: '', disablePadding: true },
        loadComponent: () => import('@features/auth/pages/callback/callback').then(m => m.CallbackComponent)
    },

    // Data processing consent – no guard, reachable by authenticated users before consent is given
    {
        path: 'consent',
        data: { headerType: '', disablePadding: true },
        loadComponent: () => import('@features/auth/pages/consent/consent').then(m => m.ConsentComponent)
    },

    // Redirect root to auth/login or landing based on auth status
    {
        path: '',
        pathMatch: 'full',
        canActivate: [AuthRedirectGuard],
        children: []
    },

    // Public Routes - No auth
    {
        path: '',
        data: { headerType: 'unlogged' },
        loadChildren: () => import('@features/auth/auth.routes').then(m => m.AUTH_ROUTES)
    },

    // Protected routes
    {
        path: '',
        canActivateChild: [AuthGuard],
        children: [
            // Users
            {
                path: '',
                loadChildren: () => import('@features/users/users.routes').then(m => m.USERS_ROUTES)
            },

            // Resources
            {
                path: 'resources',
                loadChildren: () => import('@features/resources/resources.routes').then(m => m.RESOURCES_ROUTES)
            },

            // Documents
            {
                path: 'document',
                loadChildren: () => import('@features/documents/documents.routes').then(m => m.DOCUMENTS_ROUTES)
            },

            // Events
            {
                path: 'event',
                loadChildren: () => import('@features/events/events.routes').then(m => m.EVENTS_ROUTES)
            },

            // Monitor
            {
                path: 'monitor',
                loadChildren: () => import('@features/monitor/monitor.routes').then(m => m.MONITOR_ROUTES)
            },

            // UAS
            {
                path: 'uas',
                loadChildren: () => import('@features/uas/uas.routes').then(m => m.UAS_ROUTES)
            },

            {
                path: 'installation-alert',
                data: {
                    headerType: 'logged',
                    listValue: true,
                    icon: 'general'
                },
                loadComponent: () => import('@features/monitor/pages/installation-alert/installation-alert').then(m => m.InstallationAlertComponent)
            },
            {
                path: 'installation-activation',
                data: {
                    headerType: 'logged',
                    listValue: true,
                    icon: 'general'
                },
                loadComponent: () => import('@features/monitor/pages/installation-activation/installation-activation').then(m => m.InstallationActivationComponent)
            },

            // Issues (Admin only)
            {
                path: 'issues',
                data: {
                    headerType: 'logged',
                    icon: 'resources',
                    section: 'issues'
                },
                loadComponent: () => import('@features/resources/pages/issues/issues').then(m => m.IssuesComponent)
            },

            // Petitions
            {
                path: 'petitions',
                data: {
                    headerType: 'logged',
                    textHeader: 'petitions',
                    icon: 'resources',
                    section: 'petitions'
                },
                loadComponent: () => import('@features/resources/pages/petitions/petitions').then(m => m.PetitionsComponent)
            },

            // Access Denied
            {
                path: 'access-denied',
                data: { headerType: 'logged', subTitle: 'Access Denied', disablePadding: true },
                loadComponent: () => import('@features/errors/pages/access-denied/access-denied').then(m => m.AccessDeniedComponent)
            },

            // Catch-all 404 inside protected area
            {
                path: '**',
                data: { headerType: 'logged', subTitle: 'Not found', disablePadding: true },
                loadComponent: () => import('@features/errors/pages/not-found/not-found').then(m => m.NotFoundComponent)
            }
        ]
    }
];